import 'moment/locale/vi';

import { Component } from '@angular/core';
import * as moment from 'moment';

import { AuthService } from './shared/auth/auth.service';
import { EventsBusService } from './shared/eventsBus.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  // title = 'app works!';

  showTopBar = true;
  constructor(private eventsBus: EventsBusService, private auth: AuthService) {
    moment.locale('vi');
    this.eventsBus.showTopBar.subscribe((show: boolean) => this.showTopBar = show);
    auth.handleAuthentication();
    // console.log('Environment config', Config);
  }
}



// WEBPACK FOOTER //
// /ng-app/src/app/app.component.ts